function initCaxa() {
  const url = new URL(location.href);
  const port = url.searchParams.get("port");
  if (port) {
    sessionStorage.setItem("caxa-port", port);
  }
}
export { initCaxa };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/external/caxa/initCaxa.js